import axios from 'axios'

export const instance = axios
